<template>
  <div>
    <FrameHeader/>
    
    <!-- <div v-if="!item" class="text-dark tac p-5">Loading...</div> -->

    <div class="page-detail boxed pt-5 mt-4">
      <div class="pc-left">

        <div class="ui-card">
          <div class="pic-holder type-contain">
            <img :src="item.image">
          </div>
        </div>
      </div>
      <div class="pc-right rel">

        <div :class="['scroll-box pb-4',{'left-bottom-space': status_show_btn_cancel || status_show_btn_buy || status_show_btn_sell}]">

          <!-- name -->
          <div class="">
            <h1 class="mb-1 tac">
              {{item.name | transItemName}}
            </h1>
            <div class="tac">
              <router-link 
                class="c h-c"
                :to="{
                  name: 'assetsuit',
                  params: {
                    address: meta_item.nft_address,
                  },
                }">
                {{meta_item.nft_name}}
              </router-link>
            </div>

            <div v-if="meta_item.amount" class="t-gray tac small mr-1 mt-2">
              <i class="fas fa-user"></i>
              {{lg('',{
                en: 'You own',
                zh: '你拥有',
              })}}
              {{meta_item.amount}}
            </div>
            <div class="my-4 d-flex justify-content-center">
              
              <button 
                class="btn btn-outline-primary gray px-4 mr-3"
                style="border-radius: 12px"
                @click="setLikeStatus()" 
                >
                <i :class="['fa fa-heart mr-2',{'c':status_liked}]"></i>
                {{lg('',{
                  en: 'Like',
                  zh: '喜欢',
                })}}
                <span v-if="meta_item.like_info">
                  {{meta_item.like_info.likeNum}}
                </span>
              </button>

              <button 
                class="btn btn-outline-primary gray px-4 ml-3 d-flex align-items-center"
                style="border-radius: 12px"
                @click="showPopupShareItem()"
                >
                <i class="ui-icon-share mr-2"></i>
                {{lg('',{
                  en: 'Share',
                  zh: '分享',
                })}}
              </button>

            </div>
          </div>

          <div class="sp-box-des">
            <!-- price -->
            <div class="pt-3">
              <div v-if="meta_item.sell_info && meta_item.sell_info.currency" class="d-flex">
                <h4 class="">
                  {{lg('',{
                    en: 'PRICE',
                    zh: '价格',
                  })}}:
                  {{meta_item.sell_info.buyValue || '-'}}
                  {{lg('',$store.state.web3.account_wallet.find(coin => coin.id == meta_item.sell_info.currency).names )}}
                </h4>
                <span v-if="meta_item.sell_info.buyValue" class="t-gray ml-3">
                  (${{meta_item.sell_info.buyValue | tokenToUsd(meta_item.sell_info.currency)}} 
                  {{lg('',{
                    en: 'USD',
                    zh: '美元',
                  })}})
                </span>
              </div>
            </div>

            <!-- des -->
            <div v-if="item.description" class="">
              <h6 class="b mt-3">
                {{lg('',{
                  en: 'Description',
                  zh: '介绍',
                })}}:
              </h6>
              {{item.description}}
            </div>
          </div>

          <!-- 主要操作按钮 -->
          <div v-if="1 || status_show_btn_cancel || status_show_btn_buy || status_show_btn_sell" class="btn-box tac">
            <div class="box-holder"></div>

            
            <div class="box-main py-3 d-flex flex-column justify-content-center">

              <div v-if="!status_show_btn_sell && !status_show_btn_buy && !status_show_btn_cancel">

                <div v-if="!status_loading_meta_item">
                  <button  class="btn btn-primary cd uppercase" style="min-width: 160px;">
                    {{lg('',{
                      en: 'Currently not for sale',
                      zh: '暂时是非卖品',
                    })}}
                  </button>
                </div>
                
              </div>
              <div v-else>
                <div class="w-100">
                  
                  <span v-if="status_show_btn_cancel && status_doing_cancel" class="ui-loading-icon size-sm"></span>
                  <button v-if="status_show_btn_cancel && !status_doing_cancel" @click="btnCancelSell()" :disabled="status_doing_cancel" class="btn btn-primary uppercase btn-round" style="min-width: 130px;">
                    {{lg('cancel')}}
                  </button>


                  <button v-if="status_show_btn_buy" @click="btnToggleBuy()" class="btn btn-primary uppercase btn-round" style="min-width: 130px;">
                    {{lg('',{
                      en: 'Buy Now',
                      zh: '购买',
                    })}}
                  </button>

                  <button v-if="status_show_btn_sell" @click="btnToggleSell()" class="btn btn-primary uppercase btn-round" style="min-width: 130px;">
                    {{lg('sell')}}
                  </button>

                </div>
                <div class="mt-2" v-if="status_show_btn_buy || status_show_btn_sell">
                  <span class="t-gray">
                    {{lg('service_fee')}}
                    <b>
                      2.5%. 
                    </b> 
                  </span>

                  <span v-if="meta_item.sell_info && meta_item.sell_info.buyValue">
                    <b class="c">
                      {{meta_item.sell_info.buyValue * fee_rate | tofixed6}}
                      {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == meta_item.sell_info.currency).names )}}  
                    </b>
                    <span class="t-gray">
                      (${{meta_item.sell_info.buyValue* fee_rate | tokenToUsd(meta_item.sell_info.currency)}}
                      {{lg('',{
                        en: 'USD',
                        zh: '美元',
                      })}})
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <popBuy
          :cfg_status_poppad="cfg_status_poppad_buy"
          :item="item"
          :meta_item="meta_item"
        />

        <popSell
          :cfg_status_poppad="cfg_status_poppad_sell"
          :item="item"
          :meta_item="meta_item"
        />

      </div>

    </div>

    <FrameFooter/>

  </div>
</template>

<script>
import {mapActions} from 'vuex'

import popSell from './pop_sell.vue'
import popBuy from './pop_buy.vue'

import bus from '@/bus.js'

export default {
  name: 'detail',
  components: {
    popSell,
    popBuy,
  },
  props: [],
  data() {
    return {
      // info, trade
      on_tab: 'info',

      cfg_status_poppad_sell: false,
      cfg_status_poppad_buy: false,

      status_show_btn_cancel: false,
      status_show_btn_buy: false,
      status_show_btn_sell: false,

      status_doing_cancel: false,

      item: {},
      status_loading_meta_item: false,
      meta_item: {
        owner_info: {},
        sell_info: {},
      },
      creator_info: {},

      collection_data: {},

      status_loading_history: false,
      list_history: [],

    }
  },
  computed: {
    fee_rate(){
      let rate = '-'
      if(this.status_show_btn_sell){
        rate = 0.975
      }
      if(this.status_show_btn_buy){
        rate = 1.025
      }
      return rate
    },

    status_liked(){
      return this.uniCheckLikeStatus(this.meta_item)
    },
  },
  watch: {
    '$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    },

    '$route.params.address'(){
      this.run()
    },
    '$route.params.id'(){
      this.run()
    },
    '$route.query.owner'(){
      this.run()
    },
  },
  methods: {
    ...mapActions([
      'verifyNFTOwner',
      'cancelSell',
    ]),

    showPopupShareItem(){
      let v = this
      bus.appvue.showPopupShareItem(
        Object.assign({},v.meta_item,v.item)
      )
    },

    async setLikeStatus(){
      let v = this
      let res = await v.uniSetLikeStatus(v.meta_item, !v.status_liked)
      
      let mark = v.meta_item.like_info.likeNum += (res?1:-1)
      v.meta_item.like_info.likeNum = mark >= 0 ? mark : 0
    },

    async btnCancelSell(){
      let v = this

      var order = v.meta_item['sell_info']

      let obj = {
        address: v.$store.state.web3.account,
        address_owner: order.address,
        token_address: order.nft_address,
        token_id: order.nft_id,
        salt: order.salt,
        signature: order.signature,
        buyValue: order.buyValue,
        currency: order.currency,
        type: v.meta_item.type,
        callback: function(){
          setTimeout(function(){
            v.status_doing_cancel = false
            v.run()
          },1000)
        },
        callbackOnErr: function(){
          v.status_doing_cancel = false
        }
      }

      v.status_doing_cancel = true
      await v.cancelSell(obj)
    },

    async getData(){
      let v = this

      let res = await v.uniFetchItemInfo(v.meta_item)

      v.item = res

      v.getCreatorInfo()
    },

    async getCreatorInfo(){
      let v = this
      let res = await v.api('query_item_creator',{
        'nft_address': v.$route.params.address,
        'nft_id': v.$route.params.id,
      })

      if(res.code == 0){
        v.creator_info = res.data
      }

    },

    async getHistory(){
      let v = this

      await v.uniGetCurrentBlockNum()

      if(v.list_history.length === 0){
        v.status_loading_history = true
      }

      let res = await v.api('query_item_history',{
        nft_address: v.$route.params.address,
        nft_id: v.$route.params.id,
      },{
        vue: v,
        key_data: 'list_history',
      })

      v.status_loading_history = false
    },

    async getMetaData(){
      let v = this
      
      let res = await v.api('query_item_detail',{
        'nft_address': v.$route.params.address,
        'nft_id': v.$route.params.id,
        'owner': v.$route.query.owner,
      },{
        vue: v,
        key_ajaxing: 'status_loading_meta_item',
      })

      if(res.code == 0){
        if(!res.data.owner_info){
          res.data.owner_info = {}
        }
        v.meta_item = res.data
      }

      // meme data
      v.getData()

      // get more info
      v.getCollectionData()

      v.uniCalcItemBuySellBtnStatus(v.meta_item,v)
      return

      // 以下代码待删除todo...

      let address_my = v.$store.state.web3.account ||  ''

      // no order
      if( (!v.meta_item.sell_info.address || !v.meta_item.sell_info.id) ){
        
        // let d_owner = v.meta_item.sell_info.address || ''
        let d_owner = v.$route.query.owner

        if( d_owner.toLowerCase() === address_my.toLowerCase() ){
          let is_owner = await v.checkIsOwner()
          console.log('is_owner',is_owner)
          if(is_owner){
            v.status_show_btn_cancel = false
            v.status_show_btn_sell = true
            v.status_show_btn_buy = false
          }
          else{
            v.status_show_btn_cancel = false
            v.status_show_btn_sell = false
            v.status_show_btn_buy = false
          }
        }
        else{
          v.status_show_btn_cancel = false
          v.status_show_btn_sell = false
          v.status_show_btn_buy = false
        }
      }
      // be order
      else{
        let address_my = (v.$store.state.web3.account || '').toLowerCase()
        let address_owner = (v.meta_item.sell_info.address ||  '').toLowerCase()

        if(address_my === address_owner){
          v.status_show_btn_cancel = true
          v.status_show_btn_buy = false
          v.status_show_btn_sell = false
        }else{
          v.status_show_btn_cancel = false
          v.status_show_btn_buy = true
          v.status_show_btn_sell = false
        }
      }

    },

    async getCollectionData(){
      let v = this

      let nft_url = v.meta_item.nft_url

      if(!nft_url){
        return
      }

      let res = await fetch(nft_url)
      res = await res.json()
      
      v.collection_data = res || {}
    },

    btnToggleBuy(val){
      let v = this

      if(!v.$store.state.web3.account){
        bus.btnaccountvue.modalOpen = true
        return
      }

      // check wallet balance
      let token_type = v.meta_item.sell_info.currency
      let price = v.meta_item.sell_info.buyValue * 1.025
      let balance = v.$store.state.web3.account_wallet.find(item => item.id === token_type) || {}
      balance = balance.num

      if(price > balance){
        bus.appvue.showPopupAddFund({
          token_type: token_type,
          nft_name: v.item.name,
        })
        return
      }

      v.cfg_status_poppad_buy = val!==undefined ? val : !v.cfg_status_poppad_buy
    },

    btnToggleSell(val){
      let v = this

      v.cfg_status_poppad_sell = val!==undefined ? val : !v.cfg_status_poppad_sell
    },

    async acttionBuy(){
      let v = this
      let address_my = v.$store.state.web3.acount
      console.log(address_my)
      alert('fn acttionBuy...')
    },

    

    async checkIsOwner(){
      let v = this

      if(!v.$store.state.web3.account){
        return false
      }

      let mark = await v.verifyNFTOwner({
        address: v.$store.state.web3.account,
        NTFS_TOKEN_ADDRESS: v.$route.params.address,
        NFT_ID: v.$route.params.id,
        type: v.item.type,
      })
      console.log('checkIsOwner:',mark)
      return mark
    },

    run(){
      let v = this
      v.status_show_btn_cancel = false
      v.status_show_btn_buy = false
      v.status_show_btn_sell = false
      v.getMetaData()
    },
  },
  created() {
    let v = this

    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';
  
  .page-detail{
    .pc-right{
      // background-color: ;

      .btn-box{

        .box-holder{
          // height: 110px;
          display: none;
        }
        .box-main{
          padding-top: 50px;
          // height: 110px;
          // position: absolute;
          width: 100%;
          bottom: 0;
          left:0;
        }
      }
    }
  }

  @media(min-width: 788px){
    .page-detail{

      display: flex;
  
      .pc-left {
        width: 60%;

        .pic-holder{
          width: 100%;
          height: 400px;
        }
      }
  
      .pc-right {
        width:40%;

        .sp-box-des{
          margin-left: 50px;
        }
      }
    }
  }

  @media(max-width: 788px){
    .page-detail{
      .pc-left{
        margin-bottom: 50px;
      }

      .pc-right{

        .sp-box-des{
          margin-left: 10px;
        }
      }
    }
  }
</style>